var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialBalanceskeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.916 22.644c-1.967.027-1.968-2.916 0-2.888 1.967-.027 1.967 2.916 0 2.888z",
    fill: "#E50142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#98436D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M2.014 8.488h38.648M2.014 33.732h38.648"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#771849",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.939 27.24V15.252l-3.767 2.74M25.649 15.052s-3.951.071-3.81 5.715 1.587 6.244 3.704 6.526c2.751-.282 3.281-2.187 3.492-5.997 0-4.657-1.164-5.927-3.386-6.244zM14.361 15.052s-3.951.071-3.81 5.715 1.587 6.244 3.704 6.526c2.751-.282 3.281-2.187 3.492-5.997 0-4.657-1.164-5.927-3.386-6.244zM33.257 25.317l-.454 3.538M40.608 21.316H38.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialBalanceskeepStyle);
export default __webpack_public_path__ + "static/media/initialBalances.keepStyle.87e5c570654677aede6daeef006f9ac3.svg";
export { ForwardRef as ReactComponent };